module.exports = "/out/c873e413afc940a3e05d24d1c26625ae.svg";